namespace Nobox.Nobox {
    export interface CampaigndirectForm {
        CampaignId: Serenity.ServiceLookupEditor;
        Contact: Serenity.ServiceLookupEditor;
        ChannelId: Serenity.ServiceLookupEditor;
        ProcessBy: Serenity.ServiceLookupEditor;
        Subject: Serenity.StringEditor;
        BodyType: Serenity.EnumEditor;
        ShortLink: Serenity.BooleanEditor;
        toolbarTextArea: Serenity.Extensions.StaticTextBlock;
        BodyText: Serenity.TextAreaEditor;
        BodyHtml: Serenity.HtmlContentEditor;
        Body: Serenity.StringEditor;
        Attachment: Serenity.MultipleImageUploadEditor;
        Status: CampaignResultStatus;
        IsDirect: Serenity.IntegerEditor;
    }

    export class CampaigndirectForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Campaigndirect';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CampaigndirectForm.init)  {
                CampaigndirectForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.Extensions.StaticTextBlock;
                var w5 = s.TextAreaEditor;
                var w6 = s.HtmlContentEditor;
                var w7 = s.MultipleImageUploadEditor;
                var w8 = CampaignResultStatus;
                var w9 = s.IntegerEditor;

                Q.initFormType(CampaigndirectForm, [
                    'CampaignId', w0,
                    'Contact', w0,
                    'ChannelId', w0,
                    'ProcessBy', w0,
                    'Subject', w1,
                    'BodyType', w2,
                    'ShortLink', w3,
                    'toolbarTextArea', w4,
                    'BodyText', w5,
                    'BodyHtml', w6,
                    'Body', w1,
                    'Attachment', w7,
                    'Status', w8,
                    'IsDirect', w9
                ]);
            }
        }
    }
}
